export default "__VITE_ASSET__BTqdH4lk__"